import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable } from 'rxjs';
import { GetCustomerDTO } from 'app/dtos/customer-setting/getCustomerSettingDTO';
import { UpdateCustomerSetting } from 'app/dtos/customer-setting/updateCustomerSetting';
import { GetCustomerSettingDetailDTO } from 'app/dtos/customer-setting/getCustomerSettingDetailDTO';
import { observable } from '@circlon/angular-tree-component/lib/mobx-angular/mobx-proxy';

@Injectable({
  providedIn: 'root'
})
export class CustomerSettingService {

  constructor(private httpClientService: HttpClientService) { }

  async getCustomerSetting(id) {
    const observable: Observable<GetCustomerDTO> = this.httpClientService.get({
      controller: ControllerType.CustomerSetting,
    }, id);
    return await firstValueFrom(observable);
  }

  async getCustomerSettingDetail(id) {
    const observable: Observable<GetCustomerSettingDetailDTO> = this.httpClientService.get({
      controller: ControllerType.CustomerSetting,
      action: "detail"
    }, id);
    return await firstValueFrom(observable);
  }

  async updateCustomerSetting(updateCustomerSetting: UpdateCustomerSetting) {
    const formData = new FormData();

    // 👉 Id mutlaka eklensin
    formData.append('id', updateCustomerSetting.id?.toString());
    formData.append('moduleName', updateCustomerSetting.moduleName);

    if (updateCustomerSetting.startOfferNo !== undefined)
      formData.append('startOfferNo', updateCustomerSetting.startOfferNo?.toString());

    if (updateCustomerSetting.starteCertificateNo !== undefined)
      formData.append('starteCertificateNo', updateCustomerSetting.starteCertificateNo?.toString());

    if (updateCustomerSetting.certificatePrefix !== undefined)
      formData.append('certificatePrefix', updateCustomerSetting.certificatePrefix?.toString());

    if (updateCustomerSetting.accreditationNo)
      formData.append('accreditationNo', updateCustomerSetting.accreditationNo);

    // 👉 Dosya alanları
    if (updateCustomerSetting.stampImage)
      formData.append('stampImage', updateCustomerSetting.stampImage);

    if (updateCustomerSetting.traceabilityLogoPath)
      formData.append('traceabilityLogoPath', updateCustomerSetting.traceabilityLogoPath);

    if (updateCustomerSetting.turkakLogo)
      formData.append('turkakLogo', updateCustomerSetting.turkakLogo);

    if (updateCustomerSetting.nacLogo)
      formData.append('nacLogo', updateCustomerSetting.nacLogo);

    if (updateCustomerSetting.iasLogo)
      formData.append('iasLogo', updateCustomerSetting.iasLogo);

    if (updateCustomerSetting.otherLogo)
      formData.append('otherLogo', updateCustomerSetting.otherLogo);

    if (updateCustomerSetting.expiryDayCustomerCertificate)
      formData.append('expiryDayCustomerCertificate', updateCustomerSetting.expiryDayCustomerCertificate?.toString());
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.CustomerSetting
    }, formData);
    return await firstValueFrom(observable);
  }

  async deleteCustomerSetting(customerSettingId: number, logoPropertyName: string) {
    const observable: Observable<any> = this.httpClientService.delete({
      controller: ControllerType.CustomerSetting,
      action: "DeleteCustomerSetting",
      queryString: `logoPropertyName=${logoPropertyName}`
    }, customerSettingId);
    return await firstValueFrom(observable);
  }
}
